/**
 * @description: 异店取酒汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-yqh-report">
        <div class="yqh-list">
            <el-form :inline="true" size="small" :model="yqh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="yqh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="yqh_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="yqh_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="寄存门店">
                    <el-select v-model="yqh_list_form.deposit_shop_id" filterable clearable placeholder="请选择寄存门店">
                        <el-option v-for="item in yqh_shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="取酒门店">
                    <el-select v-model="yqh_list_form.shop_id" filterable clearable placeholder="请选择取酒门店" @change="getRoomArea($event, 'yqh')">
                        <el-option v-for="item in yqh_shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区域">
                    <el-select v-model="yqh_list_form.room_area_name" filterable clearable placeholder="请选择区域" :disabled="yqh_list_form.room_area_disabled" @change="yqhRoomArea">
                        <el-option v-for="item in room_area_list" :key="item.id" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="yqh_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="yqh_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="yqhQuery">查询</el-button>
                    <el-button @click="yqhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="yqh_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column width="130" label="寄存门店">
                    <template slot-scope="scope">
                        {{scope.row.deposit_shop_name.length > '14' ? scope.row.deposit_shop_name.slice(0, 14) + '...' : scope.row.deposit_shop_name}}
                    </template>
                </el-table-column>
                <el-table-column width="130" label="取酒门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="取酒数量"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">取酒总量:</label>
                    <div class="list-total">{{yqh_quantity}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{yqh_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="yqh_list_page"
                    :total="yqh_list_total"
                    @current-change="getYqhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="yqh_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="yqh_export_sign" v-model="yqh_export_all" @change="yqhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="yqh_export_ids" @change="yqhExportChange">
                    <el-checkbox label="deposit_shop_name">寄存门店</el-checkbox>
                    <el-checkbox label="shop_name">取酒门店</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="quantity">取酒数量</el-checkbox>
                    <el-checkbox label="buying_price">进货单价</el-checkbox>
                    <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="yqh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="yqh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                yqh_shop_list: [],
                room_area_list: [],
                goods_type_list: [],
				yqh_list_form: {
                    start_date: '',
                    end_date: '',
                    deposit_shop_id: '',
					shop_id: '',
                    goods_type: '',
                    room_area: '',
                    room_area_name: '',
                    room_area_disabled: false,
					goods_name: ''
				},
				yqh_list: [],
				yqh_list_page: 1,
                yqh_list_total: 0,
                yqh_export_sign: false,
				yqh_export_all: false,
                yqh_export_ids: [],
                yqh_export_list: ['deposit_shop_name', 'shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'buying_price', 'buying_price_total'],
                yqh_export_type: '1',
                yqh_quantity: '',
                yqh_buying_price_total: '',
            }
        },
        mounted: function() {
            // 日期
            this.yqh_list_form.start_date = moment().format('YYYY-MM-DD 08:00');
            this.yqh_list_form.end_date = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.yqhShop(resolve)
            }).then(res => {
                this.yqh_list_form.shop_id = this.yqh_shop_list[0].id;
                this.getRoomArea(this.yqh_shop_list[0].id);
                this.getGoodsType();
                this.getYqhList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.yqh_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.yqh_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.yqh_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.yqh_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.yqh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.yqh_list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.yqh_list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            yqhShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "get_all": "1"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.yqh_shop_list = res.data.response.result;
                        _this.yqh_shop_list.shift();
                        _this.setShopDefaultTime(_this.yqh_shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.yqh_list_form.room_area = '';
                    _this.yqh_list_form.room_area_name = '';
                    _this.yqh_list_form.room_area_disabled = true;
                } else {
                    _this.yqh_list_form.room_area = '';
                    _this.yqh_list_form.room_area_name = '';
                    _this.yqh_list_form.room_area_disabled = false;
                    _this.setShopDefaultTime(shop_id);
                    Vue.axios.post('Shop/getRoomArea', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_area_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            
            yqhRoomArea(val) {
				this.yqh_list_form.room_area = val.id;
				this.yqh_list_form.room_area_name = val.name;
			},
            getYqhList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport2/acrossShopTakeGoodsCount', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.yqh_list_form.start_date,
                            "end_date": _this.yqh_list_form.end_date,
							"deposit_shop_id": _this.yqh_list_form.deposit_shop_id,
							"shop_id": _this.yqh_list_form.shop_id,
							"room_area": _this.yqh_list_form.room_area || '',
							"goods_type": _this.yqh_list_form.goods_type,
							"goods_name": _this.yqh_list_form.goods_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.yqh_list_total = Number(res.data.response.result.count);
							_this.yqh_quantity = res.data.response.result.total.quantity;
							_this.yqh_buying_price_total = res.data.response.result.total.buying_price_total;
						}
						_this.yqh_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			yqhQuery() {
				this.getYqhList(1);
            },
            // 导出
            yqhExportAll(val) {
				this.yqh_export_ids = val ? this.yqh_export_list : [];
				this.yqh_export_sign = false;
			},
			yqhExportChange(val) {
				const len = val.length;
				this.yqh_export_all = len === this.yqh_export_list.length;
				this.yqh_export_sign = len > 0 && len < this.yqh_export_list.length;
			},
            yqhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport/takeDepositSumExport?bill_type=take_deposit_across_shop"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.yqh_export_ids = res.data.response.result.export_fields;
                            _this.yqh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.yqh_export_ids = _this.yqh_export_list;
                            _this.yqh_export_type = '1';
                        }
                        console.log(_this.yqh_export_type);
                        _this.yqhExportChange(_this.yqh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.yqh_list_export)
                }, function() {
                    _this.yqhExport();
                });
            },
            yqhExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport/takeDepositSumExport?bill_type=take_deposit_across_shop" +
                    "&start_date=" + this.yqh_list_form.start_date +
                    "&end_date=" + this.yqh_list_form.end_date +
                    "&deposit_shop_id=" + this.yqh_list_form.deposit_shop_id +
                    "&shop_id=" + this.yqh_list_form.shop_id +
                    "&room_area=" + (this.yqh_list_form.room_area || '') +
                    "&room_area_name=" + (this.yqh_list_form.room_area_name || '') +
                    "&goods_type=" + this.yqh_list_form.goods_type +
                    "&goods_name=" + this.yqh_list_form.goods_name +
                    "&export_fields=" + JSON.stringify(this.yqh_export_ids) +
                    "&export_type=" + this.yqh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>